import { render, staticRenderFns } from "./MigracoesSistemas.vue?vue&type=template&id=a750602e&scoped=true"
import script from "./MigracoesSistemas.vue?vue&type=script&lang=js"
export * from "./MigracoesSistemas.vue?vue&type=script&lang=js"
import style0 from "./MigracoesSistemas.vue?vue&type=style&index=0&id=a750602e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a750602e",
  null
  
)

export default component.exports